// @flow

/**
 * Returns the width and height of the ViewPort
 * @returns {{width: (number|number), height: (number|number)}}
 */
export const getViewPortSize = (): {| width: number, height: number |} => {
    const documentElement = document.documentElement;
    const height = window.innerHeight || (documentElement && documentElement.clientHeight || 0);
    const width = window.innerWidth || (documentElement && documentElement.clientWidth || 0);

    return {
        width,
        height
    };
};
